exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".position-title {\n  margin-top: 0;\n}\n\n.position-gen-row {\n  margin-top: 40px;\n}\n\n.design-panel {\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n.design-panel-heading {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.design-validate-alert {\n  margin-left: 20px;\n  margin-right: 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/voucher/voucher-gen/voucher-gen.component.css
// module id = ../../../../../src/app/modules/voucher/voucher-gen/voucher-gen.component.css
// module chunks = main